const encodeHtmlTags = str => {
  var temp = document.createElement('div')
  temp.textContent = str
  return temp.innerHTML
}

const newLineToBr = str => str.replace(/(\n)+/g, '<br>')

export { encodeHtmlTags, newLineToBr }
